module.exports = __webpack_public_path__ + "img/characters.534ed887.webp";